export default "__VITE_ASSET__Bs7QdHOs__"